import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';

/**
 * Create the selectLinStart method.
 */
export function createSelectLineStart(context: API.Context) {
  /**
   * Select the first node in a line.
   */
  return function selectLineStart(): API.Response {
    const { api, game, mutateGame, respond } = context;

    const data = mutateGame(function callMethod() {
      game.selectLineStart();
    });

    if (data) {
      data.pieces = api.getPieces();
    }

    return respond(Core.APIEvents.SelectLineStart, data);
  };
}
